import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import MappingSetValidateFormat from "./validate-status-components/MappingSetValidateFormat";
import MappingSetValidateMapping from "./validate-status-components/MappingSetValidateMapping";
import MappingSetValidateData from "./validate-status-components/MappingSetValidateData";
import MappingSetValidateDataset from "./validate-status-components/MappingSetValidateDataset";

const MappingSetValidateStatus = ({
                                      t,
                                      type
                                  }) => {
    if (type === "format") {
        return <MappingSetValidateFormat t={t} />
    }

    if (type === "mapping") {
        return <MappingSetValidateMapping t={t} />
    }

    if (type === "data") {
        return <MappingSetValidateData t={t} />
    }

    if (type === "dataset") {
        return <MappingSetValidateDataset t={t} />
    }

    return null;
}

export default compose(
    translate(),
)(MappingSetValidateStatus);